<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Create Event</h1>
        </div>

        <div class="modal-body no-pad" v-if="isEventFilled">
            <div class="flex h-full">
                <div class="account-body">
                    <form class="profile-form">

                        <div class="form-field">
                            <label>Event Title</label>
                            <input type="text" v-model="event.title">
                        </div>

                        <div class="form-field">
                            <label>Event Description</label>

                            <Editor
                                :init="{
                                    ...wysiwygOptions,
                                    plugins: wysiwygPlugins
                                }"
                                api-key="kxkhkjfta11crbajh0in2mcap04z7nt4czo9icice5ihpd8n"
                                v-model="event.description"
                            >
                            </Editor>
                        </div>

                        <div class="form-field" v-if="event.image">
                            <label>Current Image</label>
                            <div class="image-wrap" :style="{ backgroundImage: `url(${event.image})` }"></div>
                            <small>The image will be available to edit on creation of the event</small>
                        </div>

                        <div class="form-field">
                            <label>Start Date and Time</label>
                            <simple-date-time-picker
                                v-model="event.start_date">
                            </simple-date-time-picker>
                        </div>

                        <div class="form-field">
                            <label>End Date and Time</label>
                            <simple-date-time-picker
                                v-model="event.end_date">
                            </simple-date-time-picker>
                        </div>

                        <div class="form-field">
                            <label>All Day</label>
                            <CheckBox v-model="event.all_day"/>
                        </div>

                        <div class="form-field">
                            <label>Category</label>
                            <select-list
                                placeholder="Select Category"
                                route="event.categories.list"
                                value-key="id"
                                option-key="title"
                                @selected="prepareCategory"
                                class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                                :selected-option="event.event_category_id"
                            >
                            </select-list>
                        </div>

                        <div class="form-field">
                            <label>Sector</label>
                            <picker-selector
                                placeholder="Select Sectors"
                                v-model="eventSectors"
                                input-name="sectors[]"
                                @input="addSectors"
                                :options="sectors">
                            </picker-selector>
                        </div>

                        <div class="form-field">
                            <label>Location</label>
                            <picker-selector
                                placeholder="Select Locations"
                                v-model="eventLocations"
                                input-name="locations[]"
                                @input="addLocations"
                                :options="locations">
                            </picker-selector>
                        </div>

                    </form>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="left text-left">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm">Save</button>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import {useStore} from "vuex"

export default {
    name: 'EventCreate',
    props: {
        existingEvent: {
            default: null,
            required: false,
        }
    },
    mounted() {
        this.setMetaTitle('Create Event | JournoLink Control')
        this.fillEvent()
    },
    data() {
        return {
            event: {
                title: null,
                start_date: null,
                end_date: null,
                category: 0,
                description: null,
                published: false,
                all_day: false,
                event_category_id: null,
            },
            imageFile: null,
            eventLocations: null,
            eventSectors: null,
            isEventFilled: false
        }
    },
    components: {
        Editor,
    },
    computed: {
        wysiwygOptions() {
            return {
                statusbar: false,
                menubar: false,
                toolbar: 'undo redo | bold italic underline | link',
                formats: {},
                height: 200,
            }
        },
        wysiwygPlugins() {
            return ['link']
        },
        datepickerType() {
            if (this.event.all_day) {
                return 'date'
            }
            return 'datetime'
        },
        datepickerFormat() {
            switch (this.datepickerType) {
                case 'date':
                    return 'ccc dd LLL yyyy'
                case 'datetime':
                    return 'ccc dd LLL yyyy HH:mm'
            }
        },
        sectors () {
            const store = useStore()
            return store.state.sectors ?? []
        },
        locations () {
            const store = useStore()
            return store.state.locations ?? []
        },
    },
    methods: {
        fillEvent() {
            if (this.existingEvent) {
                axios.get(route('event.show', this.existingEvent))
                    .then(response => {
                        this.event = response.data.event
                        this.event.id = null;
                        this.imageFile = this.event.image_file
                        this.addSectors(response.data.event.targets.sector)
                        this.addLocations(response.data.event.targets.location)
                    })
                    .catch(e => {
                        console.error({e})
                    })
            }

            this.isEventFilled = true
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('List Event | JournoLink Control')
            this.$root.goBack()
        },
        /**
         *
         */
        saveForm() {
            axios.post(route('event.create'),
                {
                    event: this.formatEventForSave(this.event),
                    imageFileId: this.imageFile?.id ?? null,
                    locations: this.eventLocations,
                    sectors: this.eventSectors,
                })
                .then(response => {
                    this.event = response.data.event
                    this.$bus.$emit('alert.success', 'New Event has been created')
                    this.$router.push({name: 'event.list', params: {newEvent: this.event}})
                })
                .catch(e => {
                    console.error({e})
                })
        },
        addLocations(ids) {
            this.eventLocations = ids
        },
        addSectors(ids) {
            this.eventSectors = ids
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * set the category id
         * @param  {Number} categoryID
         * @return {void}
         */
        prepareCategory(categoryID) {
            this.event.event_category_id = categoryID
        },
        /**
         * Format the Event object for save
         *
         * @param  {Object} event
         * @return {Object}
         */
        formatEventForSave(event) {
            let thisEvent = _.clone(event)
            thisEvent.start_date = thisEvent.start_date && moment(thisEvent.start_date).format('YYYY-MM-DD HH:mm:ss')
            thisEvent.end_date = thisEvent.end_date && moment(thisEvent.end_date).format('YYYY-MM-DD HH:mm:ss')

            return thisEvent
        },
    },
}
</script>

<style lang="less" scoped>
.account-body {
    width: 100%;
}

.account-activity {
    width: 250px;
    font-size: 0.9rem;
    padding: 15px;
}

.image-wrap {
    background-position: 50% 50%;
    background-size: cover;
    position: relative;
    width: 24%;
    margin-right: 1%;
    height: 150px;
    border: 2px dashed #dddddd;
    color: #888888;
}
</style>
